export class ServiceBoundary {
	userId: number;
	contragentId: number;
	contragentName: string;
	agreementId: number;
	agreementNumber: string;
	regionId: number;
	regionName: string;
}
